import { render, staticRenderFns } from "./GlobalAccounts.vue?vue&type=template&id=21ee8bea&scoped=true&"
import script from "./GlobalAccounts.vue?vue&type=script&lang=js&"
export * from "./GlobalAccounts.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAccounts.vue?vue&type=style&index=0&id=21ee8bea&prod&lang=scss&"
import style1 from "./GlobalAccounts.vue?vue&type=style&index=1&id=21ee8bea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee8bea",
  null
  
)

export default component.exports